import {isAxiosError} from "axios";

export function safeJsonParse(key: any) {
    try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    } catch {
        localStorage.removeItem(key);
        return null;
    }
};

export async function makeApiRequest<T>(apiCall: () => Promise<any>, runOnClose?: () => void): Promise<{ success: boolean; data?: T; message: string; }> {
    try {
        const result = await apiCall();
        const data = result?.data;

        return {
            success: data?.status ?? true,
            data,
            message: typeof data?.message === "object" ? data.message[0] : data?.message || "Request successful",
        };
    } catch (err: any) {
        const message = isAxiosError(err)
            ? err.response?.data?.message || "Request failed"
            : err.message || "Something went wrong";

        return {
            success: false,
            data: isAxiosError(err) ? err.response?.data : undefined,
            message,
        };
    } finally {
        if (typeof runOnClose === "function") runOnClose();
    }
}
